import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilePreviewComponent } from './file-preview.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { IconModule } from 'src/app/components/icon/icon.module';
import { TooltipModule } from 'src/app/components/tooltip/tooltip.module';
import { ImagePreviewModule } from '../image-preview/image-preview.module';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { SignaturePopoverModule } from '../signature-popover/signature-popover.module';
import { ValidationRetryDialogModule } from '../validation-retry-dialog/validation-retry-dialog.module';
import { StatefulLoadingModule } from '../stateful-loading/stateful-loading.module';

@NgModule({
  declarations: [FilePreviewComponent],
  exports: [FilePreviewComponent],
  imports: [
    CommonModule,
    PdfViewerModule,
    IconModule,
    TooltipModule,
    ImagePreviewModule,
    ProgressSpinnerModule,
    SignaturePopoverModule,
    ValidationRetryDialogModule,
    StatefulLoadingModule,
  ],
})
export class FilePreviewModule {}
